<template>
  <v-container fluid class="main-container">
    <PageHeader
      header="X-ray Submission"
      :subheader="activeService.name || 'No service selected'"
    />

    <MenuItems />
  </v-container>
</template>

<script>
import { GetActiveOffsiteService } from "@/store/offsiteService";

import MenuItems from "@/components/MenuItems.vue";
import PageHeader from "@/components/PageHeader.vue";

export default {
  name: "Menu",

  components: {
    MenuItems,
    PageHeader
  },

  mounted() {
    this.activeService = GetActiveOffsiteService();
  },

  data: () => ({
    activeService: { id: null, name: null }
  })
};
</script>
